<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-start align-items-center mb-1",
            },
            [_c("h3", [_vm._v(_vm._s(_vm.$t("profile.Profile")))])]
          ),
          _c(
            "div",
            [
              _c(
                "b-card",
                { staticClass: "border" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "pr-0", attrs: { lg: "1" } },
                        [
                          _c("b-avatar", {
                            staticClass: "badge-minimal",
                            attrs: {
                              size: "50",
                              variant: "light-primary",
                              badge: "",
                              text: _vm.firstName,
                              "badge-variant": "success",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("b-col", { attrs: { lg: "8" } }, [
                        _c(
                          "div",
                          { staticClass: "Fname" },
                          [
                            _vm._v(" " + _vm._s(_vm.user.name) + " "),
                            _c("GoldUser", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.user.userLevel === "GOLD",
                                  expression: "user.userLevel === 'GOLD'",
                                },
                              ],
                              staticClass: "user-level",
                            }),
                            _c("Silver", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.user.userLevel === "REGULAR",
                                  expression: "user.userLevel === 'REGULAR'",
                                },
                              ],
                              staticClass: "user-level",
                            }),
                            _c("Platinum", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.user.userLevel === "PLATINUM",
                                  expression: "user.userLevel === 'PLATINUM'",
                                },
                              ],
                              staticClass: "user-level",
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "Email" },
                          [
                            _vm.user.emailVerified ? _c("Tick") : _vm._e(),
                            _vm._v(" " + _vm._s(_vm.user.email + " ") + " "),
                            _vm.user.verificationStatus === "APPROVED"
                              ? _c("Tick")
                              : _vm._e(),
                            _vm._v(_vm._s("" + _vm.$t("profile.KYC")) + " "),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "Data" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("profile.youId") + " " + _vm.user.id
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "Data margin-to-5px" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("profile.Last-seen") +
                                  " " +
                                  _vm.convertDate(_vm.user.createdTime)
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                      _vm.user.feedback
                        ? _c(
                            "b-col",
                            {
                              staticClass: "border rounded p-1",
                              attrs: { lg: "3" },
                            },
                            [
                              _c("div", { staticClass: "feedback" }, [
                                _vm._v(_vm._s(_vm.$t("profile.Feedback"))),
                              ]),
                              _c("div", { staticClass: "total-feedback" }, [
                                _c("div", { staticClass: "feedback-number" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        (_vm.user.feedback.positive /
                                          (_vm.user.feedback.positive +
                                            _vm.user.feedback.negative || 1)) *
                                          100
                                      ) +
                                      " % "
                                  ),
                                ]),
                                _c("div", { staticClass: "total-count" }, [
                                  _c("sub", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.user.feedback.positive +
                                            _vm.user.feedback.negative
                                        ) +
                                        ")"
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("div", { staticClass: "feed-outer" }, [
                                _c(
                                  "div",
                                  { staticClass: "feedback-positive" },
                                  [
                                    _c("GreenThumb", { attrs: { size: "30" } }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.user.feedback.positive)
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "thumb" }),
                                _c(
                                  "div",
                                  { staticClass: "feedback-positive" },
                                  [
                                    _c("RedThumb", { attrs: { size: "30" } }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.user.feedback.negative)
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.userInfo && _vm.userInfo.id
                ? _c(
                    "b-card",
                    { staticClass: "border" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-row",
                                { staticClass: "mt-1" },
                                [
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-text" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("profile.Trades")) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-amt" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.userInfo.buyTradeCount +
                                              _vm.userInfo.sellTradeCount
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "mt-1" },
                                [
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-text" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("profile.Buy")) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-amt" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.userInfo.buyTradeCount) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "mt-1" },
                                [
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-text" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("profile.Sell")) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-amt" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.userInfo.sellTradeCount) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "mt-1" },
                                [
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-text" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("profile.Avg-Pay-Time")
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-amt" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.userInfo.avgPayTime) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "vertical-line" }),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-row",
                                { staticClass: "mt-1" },
                                [
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-text" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("profile.Trade-Volume")
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-amt" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.userInfo.buyTradeVolumeUsdt +
                                              _vm.userInfo.sellTradeVolumeUsdt
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "mt-1" },
                                [
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-text" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("profile.BuyVolume")) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-amt" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.userInfo.buyTradeVolumeUsdt
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "mt-1" },
                                [
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-text" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("profile.SellVolume")) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-amt" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.userInfo.sellTradeVolumeUsdt
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "b-row",
                                { staticClass: "mt-1" },
                                [
                                  _c("b-col", [
                                    _c(
                                      "div",
                                      { staticClass: "profile-text no-wrap" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("profile.Avg-Release-Time")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("b-col", [
                                    _c("div", { staticClass: "profile-amt" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.userInfo.avgReleaseTime) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("b-modal", { attrs: { id: "modal-1", "hide-footer": "" } }, [
            _c("div", { staticClass: "mb-1 text-center modal-header-text" }, [
              _vm._v(" " + _vm._s(_vm.$t("profile.Set-Nickname")) + " "),
            ]),
            _c("div", { staticClass: "mb-1 mt-2 text-center modal-text" }, [
              _vm._v(" " + _vm._s(_vm.$t("profile.Nickname-brief")) + " "),
            ]),
            _c("div", { staticClass: "text-lable mb-1" }, [
              _vm._v(_vm._s(_vm.$t("profile.Nickname"))),
            ]),
            _c(
              "div",
              [
                _c(
                  "b-input-group",
                  {
                    staticClass: "input-group-merge",
                    attrs: { append: "0/20" },
                  },
                  [
                    _c("b-form-input", {
                      attrs: { placeholder: _vm.$t("profile.Characters") },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "d-block text-center mt-4 mb-4" },
                  [
                    _c(
                      "b-button",
                      { attrs: { variant: "outline-primary mr-2" } },
                      [_vm._v(_vm._s(_vm.$t("profile.Cancel")))]
                    ),
                    _c("b-button", { attrs: { variant: "primary" } }, [
                      _vm._v(_vm._s(_vm.$t("profile.Save"))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/profile/Profile.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import assets_rashi_coin_Edit_svg from '@/assets/rashi-coin/Edit.svg';
import assets_rashi_coin_Verify_symbol_svg from '@/assets/rashi-coin/Verify-symbol.svg';
import assets_rashi_coin_green_check_svg from '@/assets/rashi-coin/green-check.svg';
import assets_rashi_coin_green_thumb_svg from '@/assets/rashi-coin/green-thumb.svg';
import assets_rashi_coin_red_thumb_svg from '@/assets/rashi-coin/red-thumb.svg';
import * as vuex from 'vuex';
import libs_api_api from '@/libs/api/api';
import moment from 'moment';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import assets_rashi_coin_gold_user_svg from '@/assets/rashi-coin/gold-user.svg';
import assets_rashi_coin_silver_svg from '@/assets/rashi-coin/silver.svg';
import assets_rashi_coin_platinum_svg from '@/assets/rashi-coin/platinum.svg';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














export default ({
  render,
  staticRenderFns,
  components: {
    BContainer: bootstrapvue["BContainer"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BCard: bootstrapvue["BCard"],
    BAvatar: bootstrapvue["BAvatar"],
    BButton: bootstrapvue["BButton"],
    Edit: assets_rashi_coin_Edit_svg,
    Verify: assets_rashi_coin_Verify_symbol_svg,
    Tick: assets_rashi_coin_green_check_svg,
    BLink: bootstrapvue["BLink"],
    GreenThumb: assets_rashi_coin_green_thumb_svg,
    RedThumb: assets_rashi_coin_red_thumb_svg,
    BFormInput: bootstrapvue["BFormInput"],
    BInputGroupAppend: bootstrapvue["BInputGroupAppend"],
    BInputGroup: bootstrapvue["BInputGroup"],
    GoldUser: assets_rashi_coin_gold_user_svg,
    Silver: assets_rashi_coin_silver_svg,
    Platinum: assets_rashi_coin_platinum_svg
  },
  data() {
    return {
      firstName: "",
      userInfo: null
    };
  },
  computed: {
    ...vuex.mapState("user", ["user"])
  },
  mounted() {
    this.tradeSummary();
  },
  methods: {
    convertDate(date) {
      if (!date) return "";
      const str = String(date);
      if (moment(str, moment.ISO_8601, true).isValid()) {
        return moment(str).format("DD/MM/YYYY");
      }
      const withZ = (str.endsWith("Z") || str.includes("+")) ? str : `${str}Z`;
      if (moment(withZ, moment.ISO_8601, true).isValid()) {
        return moment(withZ).format("DD/MM/YYYY");
      }
      if (moment(date).isValid()) {
        return moment(date).format("DD/MM/YYYY");
      }
      return date;
    },
    async tradeSummary() {
      try {
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/user/tradeSummary`
        }, {}, {
          isLoading: true
        });
        if (res && res.stats30Days) {
          this.userInfo = res.stats30Days;
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    }
  }
});

//# sourceURL=webpack:///./src/views/profile/Profile.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
[dir] .margin-to-5px {
  margin-top: 4px;
}
.Fname {
  color: var(--text-black-color);
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
}
.Email {
  color: #24ae64;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
}
[dir] .Email {
  margin: 5px 0px 7px 0px;
}
.Data {
  color: #81858c;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
}
.thumb {
  display: inline;
  height: 12px;
}
[dir] .thumb {
  margin: 0px 7px 0px 7px;
}
[dir=ltr] .thumb {
  border-right: 1px solid #d5dae0;
}
[dir=rtl] .thumb {
  border-left: 1px solid #d5dae0;
}
.feedback {
  color: #81858c;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
.feedback-number {
  color: #121214;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
}
.feedback-number-percent {
  color: #121214;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}
.profile-amt {
  display: flex;
  justify-content: flex-end;
  color: var(--text-black-color);
  font-size: 13.563px;
  font-weight: 400;
  line-height: 22px;
}
.profile-text {
  color: var(--text-black-color);
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
}
.modal-text {
  color: #777575;
  font-size: 17px;
  font-weight: 500;
  line-height: 29px;
}
[dir] .modal-text {
  text-align: center;
}
.modal-header-text {
  color: var(--text-black-color);
  font-size: 25px;
  font-weight: 500;
  line-height: 21px;
}
.vertical-line {
  width: 2px;
  height: 150px;
}
[dir] .vertical-line {
  background: #f0f0f0;
}
.total-feedback {
  display: flex;
  align-items: center;
}
.total-feedback .total-count {
  color: #121214;
}
[dir=ltr] .total-feedback .total-count {
  margin-left: 3px;
}
[dir=rtl] .total-feedback .total-count {
  margin-right: 3px;
}
.feed-outer {
  display: flex;
  align-items: center;
}
.feedback-positive {
  display: flex;
  align-items: center;
}
.feedback-positive span {
  font-size: 13px;
}
[dir=ltr] .feedback-positive span {
  margin-left: 3px;
}
[dir=rtl] .feedback-positive span {
  margin-right: 3px;
}
</style>
